import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormPentagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-pentagon"} maskId="square-filled-radius-0-stroke-1-IconFormPentagon"><path d="M22.0996 8.71875L18.2422 20.5898H5.75977L1.90234 8.71875L12.001 1.38184L22.0996 8.71875Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormPentagon;
